import {Currencies, useAccountQuery} from 'api/generated';

export const useDefaultCurrency = (accountId?: string) => {
  const {data: accountData, loading, error} = useAccountQuery({
    variables: {id: accountId!},
    skip: !accountId
  });

  const currency = accountData?.account?.defaultCurrency || Currencies.EUR;
  const currencyFormat = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency
  });

  return {currency, currencyFormat, loading, error};
};
